<template>
  <div>
    <v-container>
      <v-row>
        <v-col cols="12" align="center">
          <div class="d-flex d-sm-none">
            <v-date-picker
              :allowed-dates="allowedDates"
              @input="onChange"
              style="margin: auto"
              full-width
              no-title
              v-model="picker"
              range
            ></v-date-picker>
          </div>
          <div class="d-none d-sm-flex">
            <v-date-picker
              @input="onChange"
              style="margin: auto"
              no-title
              :allowed-dates="allowedDates"
              v-model="picker"
              range
            ></v-date-picker>
          </div>
        </v-col>
        <v-col cols="12" align="center">
          <span v-if="err" style="color: red">{{ err }}</span>
          <v-row align="center" justify="center">
            <v-col cols="3">
              <v-btn
                :loading="loading"
                :disabled="loading"
                @click="sendDateBtn"
                x-large
                color="primary"
                >Send</v-btn
              >
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </v-container>
  </div>
</template>

<script>
/* eslint-disable no-console */
import moment from "moment";
import axios from "axios";

export default {
  data() {
    return {
      picker:
        ["111105780576243", "1772973606299543"].includes(
          this.$route.query.pageid,
        ) && moment().year() == 2020
          ? ["2021-01-01"]
          : ["", ""],
      publicPath: process.env.BASE_URL,
      err: "",
      loading: false,
    };
  },
  computed: {
    filterPick() {
      return this.picker.map((v) => moment(v).format("DD/MM/YYYY"));
    },
  },
  async mounted() {
    try {
      if (process.env.VUE_APP_CALENDAR_LIFF_ID && this.$liff) {
        await this.$liff.init({ liffId: process.env.VUE_APP_CALENDAR_LIFF_ID });
      }
    } catch (error) {
      console.error("LIFF Init Error:", error);
    } finally {
      await this.$nextTick();
      this.picker = [];
    }
  },
  methods: {
    onChange(v) {
      try {
        if (v && v.length > 0) {
          this.picker = v.filter((date) => date).sort();
        } else {
          this.picker = [];
        }
      } catch (error) {
        console.error("Error onChange:", error);
      }
    },
    sendDateBtn() {
      try {
        if (this.picker[1]) {
          this.loading = true;
          if (this.$liff && this.$liff.isInClient()) {
            this.sendDateLine();
          } else {
            this.sendDateFb();
          }
        } else {
          this.err = "Please select check-in and check-out dates.";
        }
      } catch (error) {
        console.error("Error sendDateBtn:", error);
      }
    },
    allowedDates(val) {
      if (
        ["111105780576243", "1772973606299543"].includes(
          this.$route.query.pageid,
        )
      ) {
        return (
          val >= moment().format("YYYY-MM-DD") &&
          val >= moment("2021-01-01").format("YYYY-MM-DD")
        );
      } else {
        return val >= moment().format("YYYY-MM-DD");
      }
    },
    sendDateLine() {
      let vm = this;
      if (
        typeof vm.$liff !== "undefined" &&
        typeof vm.$liff.sendMessages === "function"
      ) {
        vm.$liff
          .sendMessages([
            {
              type: "text",
              text: `${this.filterPick[0]}-${this.filterPick[1]}`,
            },
          ])
          .then(() => {
            this.loading = false;
            vm.$liff.closeWindow();
          })
          .catch((error) => {
            console.error("Error sendDateLine:", error);
            alert("กรุณาติดต่อผู้ดูแลระบบ (Send date line)");
          });
      } else {
        /* eslint-disable no-undef */
        // MessengerExtensions.requestCloseBrowser(
        //   function success() {},
        //   function error() {
        //     close();
        //     window.close();
        //     // location.reload();
        //   }
        // );
        /* eslint-enable no-undef */
      }
    },
    sendDateFb() {
      let pageid = this.$route.query.pageid;
      let userid = this.$route.query.userid;
      let data = {
        pageid,
        userid,
        strdate: `${this.filterPick[0]}-${this.filterPick[1]}`,
      };

      axios.defaults.headers.common = {
        AUTHORIZATION: "BEARER " + "xxx" + " " + "xxx",
      };

      axios
        .post("https://api-enterprise.zwiz.app/hopinnselecteddate", data)
        .then(() => {
          this.loading = false;
          /* eslint-disable no-undef */
          if (window.MessengerExtensions) {
            MessengerExtensions.requestCloseBrowser(
              function success() {},
              function error(err) {
                console.error(err);
                try {
                  close();
                  window.close();
                } catch (error) {
                  console.error(error);
                }
                setTimeout(() => {
                  window.location.href = `https://m.me/${pageid}`;
                }, 300);
              },
            );
          } else {
            try {
              close();
              window.close();
            } catch (error) {
              console.error(error);
            }
            setTimeout(() => {
              window.location.href = `https://m.me/${pageid}`;
            }, 300);
          }
          /* eslint-enable no-undef */
        })
        .catch((error) => {
          console.error("Error sendDateFb:", error);
          alert("กรุณาติดต่อผู้ดูแลระบบ (Send date facebook)");
        });
    },
  },
  watch: {
    picker(newVal) {
      let vm = this;
      if (newVal[1] && newVal[1] <= newVal[0]) {
        vm.picker = [newVal[1]];
      }
      this.err = "";
    },
  },
};
</script>
